import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-quarterly-report-header',
  templateUrl: './quarterly-report-header.component.html',
  styleUrls: ['./quarterly-report-header.component.scss']
})
export class QuarterlyReportHeaderComponent {
  @Input() logoPath: string;
  @Input() header: string;
}
